import { axiosInstance } from '@/core/services';
import { PaginatedAuditLogDto, AuditLogDto } from '@aphp-ema/common/audit';

const API_BASE_URL =
  (import.meta.env.VITE_API_URL as string) || 'http://localhost:3000/api';

export const getAuditLogs = async (
  page = 1,
  limit = 100,
): Promise<PaginatedAuditLogDto> => {
  const params = new URLSearchParams();
  params.append('page', page.toString());
  params.append('limit', limit.toString());

  const response = await axiosInstance.get(
    `${API_BASE_URL}/admin/audit-logs?${params.toString()}`,
  );

  return response.data;
};

export const getAuditTrail = async (
  resourceId: string,
): Promise<AuditLogDto[]> => {
  if (!resourceId) {
    throw new Error('resourceId is required to fetch audit trail.');
  }

  const response = await axiosInstance.get(
    `${API_BASE_URL}/admin/audit-logs/trail/${resourceId}`,
  );

  return response.data;
};
